<template>
	<div>
		<div class="returnBut" @click="returnBut" :style="{background:dynamicColor.rgb}">
			<img src="../../../static/images/return_b.png" alt="">
			<p>返回</p>
		</div>
		<div class="listWrap" v-for="(item,index) in list" v-if="list.length != 0">
			<div class="list">
				<h3>{{item.key}}</h3>
				<ul class="uls">
					<li v-for="(e,x) in item.list">
						<div class="ulsLiLeft">
							<p>{{e.name}}&nbsp;&nbsp;:{{e.type}}</p>
							<p>{{e.time}}</p>
						</div>
						<div class="ulsRight">
							<p :style="{color:e.status == '审核中'||e.status == '提现信息不正确，请重新提交'?'#878787':''}">{{e.value}}</p>
							<p :style="{color:dynamicColor.rgb}">{{e.status}}</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="noData" v-if="list.length == 0">
			<img src="/static/images/empty.png" alt="">
			<p>暂无数据</p>
		</div>
	</div>
</template>

<script>
    import {Toast} from "vant";

    export default {
        name: "index",
        data(){
            return{
                apiName:'',
                list:[],
                dynamicColor:{},
            }
        },
		created() {
            this.dynamicColor = JSON.parse(localStorage.getItem('bakColor'));
            this.apiName = this.API1url.API;
            this.$get(this.apiName.withdrawList,{
                token:localStorage.getItem('token')
            }).then(res=>{
                if(res.code == '0000'){
                    var str = res.data;
                    var arr = [];

                    var map = {};

                    for (var i = 0;i < str.length; i++){
                        var ai = str[i];
                        var spl = ai.date.split('-');
                        var month = spl[1]>=10?spl[1]:'0'+spl[1];
                        var day = spl[2]>=10?spl[2]:'0'+spl[2];
                        ai.date = month+'-'+day;
                        if(!map[ai.date]){
                            arr.push({
                                key:ai.date,
                                list:[ai]
                            })
                            map[ai.date] = ai;
                        }else{
                            for(var j = 0; j < arr.length; j++){
                                var dj = arr[j];
                                if(dj.key == ai.date){
                                    dj.list.push(ai);
                                    break;
                                }
                            }
                        }
                    }


                    // str.forEach((item,index)=>{
                    //     var spl = item.date.split('-');
                    //     var month = spl[1]>=10?spl[1]:'0'+spl[1];
                    //     var day = spl[2]>=10?spl[2]:'0'+spl[2];
                    //     item.date = month+'-'+day;
                    //     if(arr.length == 0){
                    //         arr.push({
                    //             key:item.date,
                    //             list:[item]
                    //         })
                    //     }else{
                    //         arr.forEach((e,x)=>{
                    //             if(item.date == e.key){
                    //                 e.list.push(item);
                    //             }else{
                    //                 arr.push({
                    //                     key:item.date,
                    //                     list:[item]
                    //                 })
                    //             }
                    //         })
                    //     }
                    // });
                    // console.log(arr)
                    this.list = arr;
                }else{
                    Toast.fail('加载失败');
                }
            })
        },
        methods:{
            returnBut(){
                this.$router.replace('/Withdraw');
            }
        }
    }
</script>

<style scoped>
	.listWrap{
		width: 100%;
		margin-top: 16px;
	}
	.list>h3{
		font-size: 20px;
		font-family: FZCYJ;
		font-weight: bold;
		margin-left: 16px;
	}
	.uls>li{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 15px 15px 15px;
		border-bottom: 1px solid #ebebeb;
	}
	.listWrap:last-child>.list>.uls>li:last-child{
		border: none;
	}
	.ulsLiLeft>p:nth-child(1){
		font-size: 16px;
		margin-bottom: 5px;
	}
	.ulsLiLeft>p:nth-child(2){
		font-size: 14px;
		color: #878787;
	}
	.ulsRight>p:nth-child(1){
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 5px;
		text-align: right;
	}
	.ulsRight>p:nth-child(2){
		/*color: #2f80ed;*/
		font-size: 14px;
		text-align: center;
	}
	.returnBut{
		width: 100%;
		height: 40px;
		/*margin: 8px 0 0 16px;*/
		padding-left: 16px;
		display: flex;
		align-items: center;
	}
	.returnBut>img{
		width: 15px;
		height: 18px;
	}
	.returnBut>p{
		color: #ffffff;
		font-size: 16px;
		font-weight: bold;
	}
	.noData{
		width: 80px;
		color: #878787;
		font-size: 16px;
		margin: 30px auto 50px;
		text-align: center;
	}
	.noData>img{
		width: 59px;
		height: 59px;
		display: block;
		margin: 0 auto;
		margin-bottom: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/withdrawalsRecord/index.vue